import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  tourDone,
  updateTourStatus,
  changeTourActive,
  changeRunTour,
} from './Action'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import $ from 'jquery'
import Joyride from 'react-joyride'
import { injectIntl } from 'react-intl'

const allSection = [
  'Personal Information',
  'Profile Picture',
  'Headline',
  'Summary',
  'Experience',
  'Education',
]

const editTourSection = ['Headline', 'Summary', 'Experience', 'Education']

const editTourSectionAll = [
  'Profile Picture',
  'Personal Information',
  'Headline',
  'Summary',
  'Experience',
  'Education',
]

class Tour extends Component {
  constructor(props) {
    super(props)
    this.state = {
      totalStep: 0,
      currentStep: 0,
      tourelement: 'detailed',
    }

    const { intl } = props

    this.steps = {
      detailed: [
        {
          img: '/aspire/dist/images/tour/tour_profile.svg',
          target: '.left-nav-top-info-section',
          title: intl.formatMessage({ id: 'tour.profile_strength', defaultMessage: 'Profile Strength' }),
          content: intl.formatMessage({ id: 'tour.profile_strength.content', defaultMessage: 'View your overall profile strength benchmarked against 100+ scoring parameters. Get an indication of how optimized your LinkedIn profile is.' }),
          disableBeacon: true,
          placement: 'right',
          condition: 'leftNav',
        },
        {
          img: '/aspire/dist/images/tour/tour_left_nav.svg',
          target: '.left-nav-ul',
          title: intl.formatMessage({ id: 'tour.navigate_sections', defaultMessage: 'Navigate to Sections' }),
          content: intl.formatMessage({ id: 'tour.navigate_sections.content', defaultMessage: 'Navigate to different sections of your LinkedIn profile through this panel. Click on any section to get a detailed feedback and guidelines on the same.' }),
          placement: 'right',
          disableBeacon: true,
          condition: 'leftNav',
        },
        {
          img: '/aspire/dist/images/tour/tour_edit.svg',
          target: '.p-section-headline',
          title: intl.formatMessage({ id: 'tour.edit_improve', defaultMessage: 'Edit and Improve' }),
          content: intl.formatMessage({ id: 'tour.edit_improve.content', defaultMessage: 'Edit specific sections of your LinkedIn profile by using edit feature.' }),
          disableBeacon: true,
          condition: 'notEditModal',
        },
        {
          img: '/aspire/dist/images/tour/tour_section.svg',
          target: '.feedback-panel',
          title: intl.formatMessage({ id: 'tour.section_breakdown', defaultMessage: 'LinkedIn Section Breakdown' }),
          content: intl.formatMessage({ id: 'tour.section_breakdown.content', defaultMessage: 'Get an overall feedback on top sections of your LinkedIn profile. Click on any section to view detailed feedback.' }),
          disableBeacon: true,
          placement: 'left',
          condition: 'noSectionSelect',
        },

        {
          img: '/aspire/dist/images/tour/tour_sub_section.svg',
          target: '.feedback-pdf-right',
          title: intl.formatMessage({ id: 'tour.section_feedback', defaultMessage: 'Section Feedback' }),
          content: intl.formatMessage({ id: 'tour.section_feedback.content', defaultMessage: 'In each section, get detailed feedback and recommendations to improve your profile.' }),
          disableBeacon: true,
          placement: 'left',
          condition: 'sectionSelectAny',
        },
        {
          img: '/aspire/dist/images/tour/tour_sub_nav.svg',
          target: '#parameters-navigation-tab',
          title: intl.formatMessage({ id: 'tour.evaluation_parameters', defaultMessage: 'Section Evaluation Parameters' }),
          content: intl.formatMessage({ id: 'tour.evaluation_parameters.content', defaultMessage: 'These are the core parameters recruiters look at while assessing your LinkedIn profile.' }),
          disableBeacon: true,
          placement: 'left',
          condition: 'sectionSelect',
        },
        {
          img: '/aspire/dist/images/tour/tour_sub_desc.svg',
          target: '#parameters-navigation-content',
          title: intl.formatMessage({ id: 'tour.core_elements', defaultMessage: 'Core Elements' }),
          content: intl.formatMessage({ id: 'tour.core_elements.content', defaultMessage: 'We give you detailed feedback on the recruiter’s areas of focus and mention the guidelines on these elements wherever necessary.' }),
          disableBeacon: true,
          placement: 'left',
          condition: 'sectionSelect',
        },
        {
          img: '/aspire/dist/images/tour/tour_previous_edit.svg',
          target: '.last-saved-btn',
          title: intl.formatMessage({ id: 'tour.previous_edits', defaultMessage: 'Previous Edits' }),
          content: intl.formatMessage({ id: 'tour.previous_edits.content', defaultMessage: 'Click here to check the previous edits made and keep a track of all your edits.' }),
          disableBeacon: true,
        },

        {
          img: '/aspire/dist/images/tour/tour_resume.svg',
          target: '.js-detailed-add-resume',
          title: intl.formatMessage({ id: 'tour.add_resume', defaultMessage: 'Add Resume' }),
          content: intl.formatMessage({ id: 'tour.add_resume.content', defaultMessage: 'Add your resume to identify the skills gaps and ensure consistency between your resume and LinkedIn profile.' }),
          disableBeacon: true,
        },
        {
          img: '/aspire/dist/images/tour/tour_tf.svg',
          target: '.js-detailed-target-functions',
          title: intl.formatMessage({ id: 'tour.target_functions', defaultMessage: 'Select Target Functions' }),
          content: intl.formatMessage({ id: 'tour.target_functions.content', defaultMessage: 'Modify your target function to discover the best fit and curate your feedback based on that.' }),
          disableBeacon: true,
        },
        {
          img: '/aspire/dist/images/tour/tour_linkedin.svg',
          target: '.integrate-to-linkedin-appbar-btn',
          title: intl.formatMessage({ id: 'tour.update_linkedin', defaultMessage: 'Update LinkedIn' }),
          content: intl.formatMessage({ id: 'tour.update_linkedin.content', defaultMessage: 'Click on Update LinkedIn button to see all the changes made on Aspire and copy/paste them to your LinkedIn Profile.' }),
          disableBeacon: true,
        },
        {
          img: '/aspire/dist/images/tour/tour_download.svg',
          target: '.three-dots-dropdown-app-bar',
          title: intl.formatMessage({ id: 'tour.download_profile', defaultMessage: 'Download Profile' }),
          content: intl.formatMessage({ id: 'tour.download_profile.content', defaultMessage: 'Download your improved profile in a PDF format from here.' }),
          placement: 'left',
          disableBeacon: true,
        },
      ],
      summary: [
        {
          img: '/aspire/dist/images/tour/tour_sub_section.svg',
          target: '.feedback-pdf-right',
          title: intl.formatMessage({ id: 'tour.section_feedback', defaultMessage: 'Section Feedback' }),
          content: intl.formatMessage({ id: 'tour.section_feedback.content', defaultMessage: 'In each section, get detailed feedback and recommendations to improve your profile.' }),
          placement: 'left',
          disableBeacon: true,
        },
        {
          img: '/aspire/dist/images/tour/tour_sub_nav.svg',
          target: '#parameters-navigation-tab',
          title: intl.formatMessage({ id: 'tour.evaluation_parameters', defaultMessage: 'Section Evaluation Parameters' }),
          content: intl.formatMessage({ id: 'tour.evaluation_parameters.content', defaultMessage: 'These are the core parameters recruiters look at while assessing your LinkedIn profile.' }),
          placement: 'left',
          disableBeacon: true,
        },
        {
          img: '/aspire/dist/images/tour/tour_sub_desc.svg',
          target: '#parameters-navigation-content',
          title: intl.formatMessage({ id: 'tour.core_elements', defaultMessage: 'Core Elements' }),
          content: intl.formatMessage({ id: 'tour.core_elements.content', defaultMessage: 'We give you detailed feedback on the recruiter’s areas of focus and mention the guidelines on these elements wherever necessary.' }),
          placement: 'left',
          disableBeacon: true,
        },
      ],
    }
  }

  getSteps(tourelementSteps, tourelement) {
    const { currentStep, totalStep } = this.state
    const {
      isEditModal,
      ui,
      isLeftNavExpand,
      hasResume,
      normalResume,
      allSmallResume,
    } = this.props
    let currentSectionName = this.props.ui.section
    let currentIndex = ui[currentSectionName]['currentIndex']
    let finalStep = _.filter(tourelementSteps, (step, i) => {
      if (tourelement === 'detailed') {
        if (i == 2) {
          if (currentSectionName === 'Personal Information') {
            step.target = '.p-section-pi'
          } else if (currentSectionName === 'Profile Picture') {
            step.target = '.p-section-img'
          } else if (currentSectionName === 'Summary') {
            step.target = '.p-section-summary'
          } else if (currentSectionName === 'Headline') {
            step.target = '.p-section-headline'
          } else if (['Experience', 'Education'].includes(currentSectionName)) {
            if (_.isEmpty(currentIndex)) {
              step.target = `.p-sub-section-${currentSectionName}-first`
            } else {
              step.target = '.p-sub-section-select'
            }
          } else {
            step.target = '.p-section-headline'
          }

          if (
            ['Summary', 'Experience', 'Education'].includes(currentSectionName)
          ) {
            let elemEdit = document.getElementsByClassName(
              step.target.substring(1)
            )
            if (elemEdit.length <= 0) {
              step.target = `.p-section-empty-${currentSectionName}`
            }
          }
        }
        if (!_.isUndefined(step.condition)) {
          if (step.condition === 'leftNav' && !isLeftNavExpand) {
            return false
          }
          if (step.condition === 'notEditModal' && isEditModal) {
            return false
          }
          if (step.condition === 'noSectionSelect') {
            if (allSection.includes(currentSectionName)) {
              return false
            }
          }
          if (step.condition === 'sectionSelect') {
            if (editTourSection.includes(currentSectionName)) {
              if (
                ['Experience', 'Education'].includes(currentSectionName) &&
                _.isEmpty(currentIndex)
              ) {
                return false
              }
            } else {
              return false
            }
          }
          if (step.condition === 'sectionSelectAny') {
            if (editTourSectionAll.includes(currentSectionName)) {
              let isEmptySection = _.isEmpty(
                ui['sections'][currentSectionName]['section_score']
              )
              if (
                ['Experience', 'Education'].includes(currentSectionName) &&
                _.isEmpty(currentIndex) &&
                !_.isEmpty(ui['sections'][currentSectionName]['section_score'])
              ) {
                return false
              } else if (
                ['Profile Picture', 'Personal Information'].includes(
                  currentSectionName
                )
              ) {
                return true
              }
            } else {
              return false
            }
          }
        }
        if (
          step.title === this.props.intl.formatMessage({ id: 'tour.add_resume', defaultMessage: 'Add Resume' }) ||
          step.title === 'Add Resume'
        ) {
          let addResumeText = hasResume
            ? this.props.intl.formatMessage({ id: 'tour.change_resume', defaultMessage: 'Change' }) + ' ' + normalResume
            : this.props.intl.formatMessage({
                id: 'tour.add_resume1',
                defaultMessage: 'Add {resume}',
              }, {resume: normalResume})
          step.title = addResumeText
          if (addResumeText.includes(this.props.intl.formatMessage({ id: 'tour.change_resume', defaultMessage: 'Change' }))) {
            step.content =
              this.props.intl.formatMessage({ id: 'tour.change_resume.content', defaultMessage: 'Change your {resume} to identify the skills gaps and ensure consistency between your {resume} and LinkedIn profile.' }, { resume: allSmallResume })
          } else {
            step.content =
              this.props.intl.formatMessage({ id: 'tour.add_resume.content', defaultMessage: 'Add your {resume} to identify the skills gaps and ensure consistency between your {resume} and LinkedIn profile.' }, { resume: allSmallResume })
          }
        }
      }
      let elem = document.getElementsByClassName(step.target.substring(1))
      if (elem.length <= 0) {
        let idElement = document.getElementById(step.target.substring(1))
        if (idElement) {
          return true
        }
        return false
      }
      return true
    })
    finalStep = _.map(finalStep, (step, i) => {
      let element = document.getElementsByClassName(step['target'].substring(1))
      let idElement
      if (element.length <= 0) {
        idElement = document.getElementById(step['target'].substring(1))
      }
      let content = ''
      if (element.length > 0 || idElement) {
        content = (
          <div className="tour-content row">
            <div className="tour-icon col-sm-2">
              <img
                src={step['img']}
                height="46px"
                width="46px"
                alt="info-image"
              />
            </div>
            <div className="tour-content-text col-sm-10">
              <div
                className="tour-heading"
                style={{ fontWeight: 600, marginBottom: '10px' }}
              >
                {step.title}
                {currentStep > 0 || totalStep > 1 ? (
                  <span className="tour-steps float-end">
                    <span className="current-step">{currentStep + 1}</span>
                    <span className="total-step">/{totalStep}</span>
                  </span>
                ) : null}
              </div>
              <div className="tour-content-desc">{step.content}</div>
            </div>
          </div>
        )
      }
      let newStep = { ...step, content: content }
      delete newStep.img
      delete newStep.title
      return newStep
    })
    return finalStep
  }

  componentDidMount() {
    var id = this.state.tourelement
    if (this.props.tourstatus[id] === 0) {
      this.hashLinkScroll()
      sendTrackingData('event', 'aspire_tour', 'click', 'first_run')
      setTimeout(() => {
        this.runTour()
      }, 100)
      var tempstatus = this.props.tourstatus
      tempstatus[id] = 1
      this.props.updateTourStatus(tempstatus, id)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { ui } = this.props
    let currentSectionName = this.props.ui.section
    let currentIndex = ui[currentSectionName]['currentIndex']
    let newTourelement = 'detailed'
    let tempstatus = this.props.tourstatus
    if (
      (editTourSection.includes(currentSectionName) &&
        !editTourSection.includes(prevProps.ui.section)) ||
      currentIndex !== prevProps.ui[currentSectionName]['currentIndex']
    ) {
      if (
        ['Experience', 'Education'].includes(currentSectionName) &&
        _.isNull(currentIndex)
      ) {
        newTourelement = 'detailed'
      } else if (
        editTourSection.includes(currentSectionName) &&
        !_.isNull(currentIndex)
      ) {
        if (tempstatus['detailed'] === 0) {
          newTourelement = 'detailed'
        } else if (
          tempstatus['detailed'] === 1 &&
          tempstatus['summary'] === 0
        ) {
          newTourelement = 'summary'
        } else {
          newTourelement = 'detailed'
        }
      }
      this.setState({
        tourelement: newTourelement,
      })
    }
    if (this.props.startTour && !this.props.isRunTour) {
      this.hashLinkScroll()
      sendTrackingData('event', 'aspire_tour', 'click', 'normal_run')
      this.runTour()
      this.props.tourDone()
    }
    if (
      prevState.tourelement !== this.state.tourelement &&
      this.state.tourelement === 'summary' &&
      !this.props.isRunTour
    ) {
      this.runTour()
    }
  }

  hashLinkScroll() {
    const { hash } = window.location
    if (hash !== '') {
      // Push onto callback queue so it runs after the DOM is updated,
      // this is required when navigating from a different page so that
      // the element is rendered on the page before trying to getElementById.
      setTimeout(() => {
        let id = hash.replace('#', '')
        if (id == 'profile_picture') {
          id = 'profile_picture_linkedin'
        }
        const element = document.getElementById(id)
        if (element) element.scrollIntoView()
      }, 0)
    }
  }

  runTour() {
    this.getSteps()
    this.props.changeRunTour(true)
    $('.tour-scroll').addClass('no-scroll')
  }

  tourCallback(tour) {
    const {
      changeTourActive,
      tourstatus,
      updateTourStatus,
      isEditModal,
      ui,
      isLeftNavExpand,
    } = this.props
    const { tourelement } = this.state
    const { action, type, index, size, step } = tour
    const { placement } = step

    let currentSectionName = this.props.ui.section
    let currentIndex = ui[currentSectionName]['currentIndex']

    this.setState({ currentStep: index, totalStep: size })
    if (type === 'tour:start') {
      this.tourActiveStatus(true)
    }
    if (type === 'step:after') {
      sendTrackingData('event', 'resume_tour', 'click', 'tour_step')
    }
    let leftNavElement = document.getElementById('left-nav-container')
    if (!_.isEmpty(step.condition) && step.condition === 'leftNav') {
      if (leftNavElement && type !== 'tour:status') {
        let leftNavTopElement = document.getElementById(
          'left-nav-top-container'
        )
        if (leftNavTopElement) {
          leftNavTopElement.scrollIntoView()
        }
        leftNavElement.style.overflow = 'hidden'
      }
    } else {
      if (leftNavElement) {
        leftNavElement.style.overflow = 'auto'
      }
    }

    let elemArrow = document.getElementsByClassName('__floater__arrow')
    if (elemArrow.length > 0) {
      if (!elemArrow[0].children[0].className.includes('__floater__stick')) {
        elemArrow[0].children[0].innerHTML = ''
        if (action === 'update') {
          elemArrow[0].children[0].className += `__floater__stick ${placement}`
        }
      }
      elemArrow[0].style.width = '0px'
    }
    if (!_.isEmpty(step.condition) && step.condition === 'notEditModal') {
      if (
        !allSection.includes(currentSectionName) ||
        (['Experience', 'Education'].includes(currentSectionName) &&
          _.isEmpty(currentIndex))
      ) {
        this.updateEditButtonClass(currentSectionName, false)
      }
    } else {
      if (
        !allSection.includes(currentSectionName) ||
        (['Experience', 'Education'].includes(currentSectionName) &&
          _.isEmpty(currentIndex))
      ) {
        this.updateEditButtonClass(currentSectionName, true)
      }
    }

    if (type === 'tour:end') {
      if (leftNavElement) {
        leftNavElement.style.overflow = 'auto'
      }
      if (action === 'skip') {
        sendTrackingData('event', 'aspire_tour', 'click', 'tour_skip')
      } else {
        sendTrackingData('event', 'aspire_tour', 'click', 'tour_end')
      }
      document.querySelectorAll('.tour-scroll').forEach(function (element) {
        element.classList.remove('no-scroll')
      })
      this.props.changeRunTour(false)
      this.tourActiveStatus(false)
      let tempStatus = tourstatus
      if (tourelement === 'summary') {
        tempStatus['summary'] = 1
        updateTourStatus(tempStatus, 'summary')
      }
    }
  }

  updateEditButtonClass(currentSectionName, isHide) {
    let editSecClassName = 'edit-sec-headline'
    if (currentSectionName === 'Personal Information') {
      editSecClassName = 'edit-sec-name'
    } else if (currentSectionName === 'Profile Picture') {
      editSecClassName = 'edit-sec-img'
    } else if (['Experience', 'Education'].includes(currentSectionName)) {
      editSecClassName = 'edit-sec-first-' + currentSectionName
    }
    let editSecElement = document.getElementsByClassName(editSecClassName)
    if (editSecElement.length > 0) {
      let additionalClassName = isHide ? 'edit-sec-hide ' : ''
      editSecElement[0].className =
        'edit-sec ' + additionalClassName + editSecClassName
    }
  }

  tourActiveStatus(status) {
    this.props.changeTourActive(status)
  }

  render() {
    const { tourstatus, isRunTour, intl } = this.props
    const { tourelement } = this.state

    const steps = this.getSteps(this.steps[tourelement], tourelement)
    return (
      <Joyride
        key={tourelement}
        steps={steps}
        run={isRunTour}
        callback={(v) => this.tourCallback(v)}
        showSkipButton={true}
        continuous={true}
        locale={{
          last: intl.formatMessage({ id: "tour.button.done", defaultMessage: "Done" }),
          skip: intl.formatMessage({ id: "tour.button.skip", defaultMessage: "Skip" }),
          next: intl.formatMessage({ id: "tour.button.next", defaultMessage: "Next" }),
          back: intl.formatMessage({ id: "tour.button.back", defaultMessage: "Back" }),
        }}
        disableScrollParentFix={true}
        styles={{
          options: {
            primaryColor: '#0075cb',
            zIndex: 2010,
            overlayColor: 'rgba(0, 0, 0, 0.8)',
          },
          buttonClose: {
            display: 'none',
          },
          tooltip: {
            width: '433px',
            padding: '24px 24px 20px 24px',
          },
          tooltipContent: {
            padding: 'none',
          },
          buttonNext: {
            backgroundColor: '#fff',
            border: '1px solid',
            color: '#0075CB',
          },
        }}
      />
    )
  }
}

const mapStateToProps = (store, ownProps) => {
  return {
    startTour: store.tour.startTour,
    tourstatus: store.tour.tourStatus,
    tourActive: store.tour.tourActive,
    isRunTour: store.tour.isRunTour,
    has_pdf: store.aspireFeedbackData.has_pdf,
    user: store.user.data,
    isEditModal: store.editData.show_edit_modal,
    ui: store.detailedFeedbackUi,
    isLeftNavExpand: store.editData.isLeftNavExpand,
    normalResume: store.aspireFeedbackData.normalResume,
    allSmallResume: store.aspireFeedbackData.allSmallResume,
    hasResume: store.aspireFeedbackData.has_resume,
  }
}

export default connect(mapStateToProps, {
  tourDone,
  updateTourStatus,
  changeTourActive,
  changeRunTour,
})(injectIntl(Tour))
